module.exports = __webpack_public_path__ + "img/thumbnail_CloudedLeopard_f_normal.28b85451.png";